export const getClientCountry = async (fetch: typeof globalThis.fetch, origin: string): Promise<{ country: string | undefined }> => {
  const response = await fetch(`${origin}/apiv2/country`);
  return response.json();
}
